import {AfterViewInit, Component, EventEmitter, HostBinding, Input, Output, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {isNullOrUndefined} from 'util';

const componentBaseName = 'form-wizard-pane';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

const Positions = {
  default: 'default',
  center: 'center',
};

@Component({
  selector: 'cat-form-wizard-pane',
  templateUrl: './form-wizard-pane.component.html',
  styleUrls: ['./form-wizard-pane.component.scss'],
})
export class FormWizardPaneComponent implements AfterViewInit {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() title: string;
  @Input() hidden = false;
  @Input() isActive = false;
  @Input() isValid = false;
  @Input() isDirty = false;
  @Input() position = Positions.default;

  @Input()
  set content(value: TemplateRef<any>) {
    this._content = value;
    this.updateContent(this.contentContainer, this._content);
  }

  @Output() next = new EventEmitter<any>();
  @Output() previous = new EventEmitter<any>();
  @Output() completed = new EventEmitter<any>();

  @ViewChild('content', {read: ViewContainerRef})
  contentContainer: ViewContainerRef;

  positions = Positions;

  private _content: TemplateRef<any>;

  constructor() {
  }

  ngAfterViewInit() {
    this.updateContent(this.contentContainer, this._content);
  }

  private updateContent(container: ViewContainerRef, content: TemplateRef<any>) {
    if (!isNullOrUndefined(container) && !isNullOrUndefined(content)) {
      container.createEmbeddedView(content);
    }
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-form/components/form-wizard-pane/form-wizard-pane.component.ts